import { gql } from "@apollo/client"

export const UpdateDeliveryMethod = gql`
mutation UpdateDeliveryMethod($updateDeliveryMethodId: ID!, $content: contentDeliveryMethod!) {
  updateDeliveryMethod(id: $updateDeliveryMethodId, content: $content) {
    status
  }
}
`